module.exports = __webpack_public_path__ + "static/media/img_leverageai.f78096de.jpg";